<div class="container-fluid">
  <h1 mat-dialog-title>
    <ng-template [ngIf]="editData.workOrder.workOrder_ID"><span i18n>Edit Work Order</span> #{{editData.workOrder.workOrder_Seq}}</ng-template>
    <ng-template [ngIf]="editData.workOrder.workOrder_ID == null" i18n>Add Work Order</ng-template>
  </h1>
  <div mat-dialog-content>
    <p i18n>A work order assigns a crew to a quote area over a certain period of time.</p>
    <form #workOrderForm="ngForm" (ngSubmit)="saveWorkOrder(workOrderForm)">
      <div class="form-group row">
        <label for="woArea" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>Work Order Area</span>
        </label>
        <div class="col-sm-8">
          <table class="table table-bidit table-striped">
            <thead>
              <tr>
                <th></th>
                <th i18n>Area</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-area [ngForOf]="editData.workOrder.areas">
                <tr *ngFor="let quoteArea of area.quoteAreas">
                  <td>
                    <input name="addWorkOrder{{quoteArea.quoteArea_ID}}" type="checkbox"
                           [(ngModel)]="quoteArea.addWorkOrder" #isSelected="ngModel" />
                  </td>
                  <td>
                    {{area.area_Name}} -
                    <span *ngIf="quoteArea.acceptedItem.area_Name != null">{{quoteArea.acceptedItem.area_Name}}</span>
                    <span *ngIf="quoteArea.acceptedItem.area_Name == null">{{quoteArea.acceptedItem.subArea.subArea_Name}}</span>
                    <img *ngIf="quoteArea.currentlyAssigned" src="assets/img/circle_images/admin_circle.png" alt="Currently Assigned" title="Currently Assigned" class="assigned-icon ml-3" />
                  </td>
                </tr>
              </ng-template>
              <tr *ngFor="let customItem of editData.workOrder.jobCustomItems">
                <td>
                  <input name="addWorkOrder{{customItem.jobCustomItem_ID}}" type="checkbox"
                         [(ngModel)]="customItem.addWorkOrder" #isSelected="ngModel" />
                </td>
                <td>
                  {{customItem.customItemDescription}} - {{customItem.customItemProduct}}
                  <img *ngIf="customItem.currentlyAssigned" src="assets/img/circle_images/admin_circle.png" alt="Currently Assigned" title="Currently Assigned" class="assigned-icon ml-3" />
                </td>
              </tr>
            </tbody>
          </table>
          <div [hidden]="areaAlert == null"
               class="alert alert-danger">
            {{areaAlert}}
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="workOrderType_ID" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>Work Order Type</span>
        </label>
        <div class="col-sm-8">
          <select class="form-control select-bidit" name="woType_ID"
                  required
                  [(ngModel)]="editData.workOrder.workOrderType_ID" #workOrderType_ID="ngModel">
            <option [ngValue]="undefined">-</option>
            <option *ngFor="let workOrderType of data.workOrderTypes" [ngValue]="workOrderType.workOrderType_ID">{{workOrderType.workOrderType_Desc}}</option>
          </select>
          <div [hidden]="!workOrderForm.submitted || workOrderType_ID.valid"
               class="alert alert-danger" i18n>Select a work order type</div>
        </div>
      </div>
      <div *ngIf="editData.workOrder.workOrder_ID" class="form-group row">
        <label for="workOrderStatus_ID" class="col-sm-4 col-form-label" i18n>Work Order Status</label>
        <div class="col-sm-8">
          <select class="form-control select-bidit" name="workOrderStatus_ID"
                  [(ngModel)]="editData.workOrder.workOrderStatus_ID" #workOrderStatus_ID="ngModel">
            <option [ngValue]="undefined">-</option>
            <option *ngFor="let workOrderStatus of workOrderStatuses" [ngValue]="workOrderStatus">{{getWorkOrderStatusName(workOrderStatus)}}</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label for="workOrder_Instructions" class="col-sm-4 col-form-label" i18n>Instructions</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="workOrder_Instructions" rows="3"
                    [(ngModel)]="editData.workOrder.workOrder_Instructions" #workOrder_Instructions="ngModel"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label for="selectedCrews" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>Crew Assigned</span>
        </label>
        <div class="col-sm-8">
          <mat-select multiple required class="form-control"
                      [(value)]="selectedCrews">
            <mat-option *ngFor="let crew of data.crews" [value]="crew">
              <div class="color-swatch"
                   [style.background-color]="crew.crew_Color">&nbsp;</div>
              {{crew.crew_Name}}
            </mat-option>
          </mat-select>
          <div [hidden]="!workOrderForm.submitted || selectedCrews.length > 0"
               class="alert alert-danger col-sm-12" i18n>Select Crew</div>
        </div>
      </div>
      <div class="form-group row">
        <label for="workOrder_Start" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>Start Date</span>
        </label>
        <div class="col-sm-8 form-inline">
          <input name="workOrder_Start" class="form-control narrow-input"
                 matInput
                 placeholder="mm/dd/yyyy"
                 required
                 [matDatepicker]="startPicker"
                 [(ngModel)]="editData.workOrder.workOrder_Start" #workOrder_Start="ngModel" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <select name="startTime" class="form-control select-bidit"
                  required
                  [(ngModel)]="editData.startTime" #startTime="ngModel">
            <option value="">-</option>
            <option *ngFor="let time of data.times" [ngValue]="time">{{time}}</option>
          </select>
        </div>
        <div [hidden]="!workOrderForm.submitted || (workOrder_Start.valid && startTime.valid)"
             class="alert alert-danger col-sm-12" i18n>Enter a valid start date and time</div>
      </div>
      <div class="form-group row">
        <label for="workOrder_Stop" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>End Date</span>
        </label>
        <div class="col-sm-8 form-inline">
          <input name="workOrder_Stop" class="form-control narrow-input"
                 matInput
                 placeholder="mm/dd/yyyy"
                 required
                 [matDatepicker]="stopPicker"
                 [(ngModel)]="editData.workOrder.workOrder_Stop" #workOrder_Stop="ngModel" />
          <mat-datepicker-toggle matSuffix [for]="stopPicker"></mat-datepicker-toggle>
          <mat-datepicker #stopPicker></mat-datepicker>
          <select name="stopTime" class="form-control select-bidit"
                  required
                  [(ngModel)]="editData.stopTime" #stopTime="ngModel">
            <option value="">-</option>
            <option *ngFor="let time of data.times" [ngValue]="time">{{time}}</option>
          </select>
        </div>
        <div [hidden]="!workOrderForm.submitted || (workOrder_Stop.valid && stopTime.valid)"
             class="alert alert-danger col-sm-12" i18n>Enter a valid end date and time</div>
      </div>
      <div [hidden]="timeAlert == null"
           class="alert alert-danger">
        {{timeAlert}}
      </div>
      <div class="form-group row">
        <label for="workOrder_IncludeWeekends" class="col-sm-4 col-form-label" i18n>Include Weekends</label>
        <div class="col-sm-8">
          <mat-radio-group area-label="Include Weekends" name="workOrder_IncludeWeekends"
                           [(ngModel)]="editData.workOrder.workOrder_IncludeWeekends">
            <mat-radio-button [value]="false" class="pr-2" i18n>No</mat-radio-button>
            <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="form-group row">
        <label for="useSameTimesMultiDay" class="col-sm-4 col-form-label" i18n>Use Same Times Multi-Day</label>
        <div class="col-sm-8">
          <mat-radio-group area-label="Use Same Times Multi-Day" name="useSameTimesMultiDay"
                           [(ngModel)]="editData.workOrder.useSameTimesMultiDay">
            <mat-radio-button [value]="false" class="pr-2" i18n>No</mat-radio-button>
            <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div *ngIf="!isRequesting" class="row">
        <div class="col-sm-9">
          <button type="submit" mat-button class="mr-2 btn btn-bidit-submit" i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <div class="col-sm-3 text-right">
          <button *ngIf="editData.workOrder.workOrder_ID" type="button" mat-button (click)="deleteWorkOrder()"
                  class="mr-2 btn btn-bidit-warn" i18n>
            Delete
          </button>
        </div>
      </div>
      <div class="row" *ngIf="isRequesting">
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
      <div [hidden]="!workOrderForm.submitted || workOrderForm.valid"
           class="mt-3 alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    </form>
  </div>
</div>
